import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const REMDOCS_REGLEMENTS_DOCUMENTS_SCHEMA_LITERAL = {
    title: 'Schéma Règlements Documents',
    description: 'Règlements Documents',
    version: 1,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        MD_CAISSE_SESSION : { type : 'string' },
        DOMAINE : { type : 'number' },
        VENTES : { type : 'string' },
        ACHATS : { type : 'string' },
        CT_NUM : { type : 'string' },
        CT_INTITULE : { type : 'string' },
    },
    required: [ ]
} as const;

const schemaTyped = toTypedRxJsonSchema(REMDOCS_REGLEMENTS_DOCUMENTS_SCHEMA_LITERAL);
export type RxRemdocsReglementsDocumentsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const REMDOCS_REGLEMENTS_DOCUMENTS_SCHEMA: RxJsonSchema<RxRemdocsReglementsDocumentsDocumentType> = REMDOCS_REGLEMENTS_DOCUMENTS_SCHEMA_LITERAL;
